import React from "react";
import SendIcon from "@mui/icons-material/Send";
import LoadingButton from "@mui/lab/LoadingButton";
import { useIsFetching } from "@tanstack/react-query";

import { ACCOUNTS_API_URLS } from "../../../../../api/accounts";

interface IProps {
  disabled: boolean;
  loading: boolean;
}
const SubmitFormButton: React.FC<IProps> = ({ disabled, loading }) => {
  const isFetchingRithmicDetails = useIsFetching({
    queryKey: [ACCOUNTS_API_URLS.getAccountDataWithRithmicDetails],
  });

  return (
    <LoadingButton
      variant="contained"
      loading={loading || isFetchingRithmicDetails > 0}
      type="submit"
      disabled={disabled}
      loadingPosition="end"
      endIcon={<SendIcon />}
    >
      <span>Send to Rithmic</span>
    </LoadingButton>
  );
};

export default SubmitFormButton;
